// @core/api/endpoints/team/list_team_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamLogsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List team activity logs
 * Returns the activity log for a team including membership changes, role updates, and administrative actions.
 */
export async function ListTeamLogs(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/logs`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamLogsResponse>(requestPath, { ...requestOptions, params });
}
